/** The id of the last expanded category. */
export const ACTIVE_CATEGORY_ID = 'activeCategoryId'
/** The id of the last opened pantry item. */
export const ACTIVE_PANTRY_ITEM_ID = 'activePantryItemId'
